import React from 'react';
import CreateEnvelope from '../documents/CreateEnvelope';

const CreateTemplate = () => <CreateEnvelope />;

export default CreateTemplate;

